import {Label} from '@primer/react'

import labelStyles from '../EntryStatusLabel.module.css'
import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {EffectiveEntryStatus as EffectiveEntryStatusType} from '../../../../helpers/effective-entry-status'

export function BlockedDownstackStatusLabel({status}: {status: EffectiveEntryStatusType}) {
  if (status !== EffectiveEntryStatus.BlockedDownstack) return null

  return (
    <Label variant="attention" className={labelStyles.solid}>
      Blocked downstack
    </Label>
  )
}
